import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  fetchRSSIHistorySuccess,
  fetchRSSIHistoryFailure,
  fetchLocationHistorySuccess,
  fetchLocationHistoryFailure,
  deviceDashboardTypes,
  fetchBatteryHistorySuccess,
  fetchBatteryHistoryFailure,
  fetchAcclerationHistorySuccess,
  fetchAcclerationHistoryFailure,
  fetchSignalHistorySuccess,
  fetchSignalHistoryFailure,
  fetchGatewayTelemetryHistorySuccess,
  fetchGatewayTelemetryHistoryFailure,
  fetchAssetHistorySuccess,
  fetchAssetHistoryFailure,
  fetchShockAlarmHistorySuccess,
  fetchShockAlarmHistoryFailure,
} from "../actions/deviceDashboard";
import {
  fetchLocationHistorymapEndPoint,
  fetchassetmapEndPoint,
  fetchDeviceEventDashboard,
} from "../../configuration";
import { getRandomUUID } from "../../Token";
import { v4 as uuidv4 } from "uuid";
import usDateFormatLast7Days from "../../global/utility/usDateFormatLast7Days";
import timeAgoCalculator from "../../global/utility/timeAgoCalculator";
import {dateFormatWithAt} from "../../global/utility/dateFormat";

function* fetchRSSIHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.rssi
      };
    });

    const rssiHistoryResponse = yield call(
      fetchRSSIAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );

    const rssiHistoryData = Object.entries(rssiHistoryResponse?.rssi || {});
    let rssiHistory = [];

    if (Array.isArray(rssiHistoryData)) {
      rssiHistoryData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
      rssiHistoryData.forEach((rssiData) => {
        rssiHistory = [...rssiHistory, [rssiData[0], rssiData[1].Value]];
      });
    }

    yield put(fetchRSSIHistorySuccess(rssiHistory));
  } catch (error) {
    yield put(fetchRSSIHistoryFailure(error.message));
  }
}

async function fetchRSSIAPI(deviceId, selectedDate, interval, resolution) {
  const dt = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchDeviceEventDashboard(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      eventtype: "rssi",
      startDate: dt.endDateTime,
      interval: interval,
      resolution: resolution
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchLocationHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
      };
    });

    const locationHistoryResponse = yield call(
      fetchLocationAPI,
      options.currentId,
      options.selectedDateTime
    );

    const locationHistoryData =
      (Array.isArray(locationHistoryResponse) &&
        locationHistoryResponse.map((locationHistory, index) => ({
          key: `${index}-${locationHistory.Timestamp}-${locationHistory.Organization}`,
          timestamp: locationHistory.Timestamp,
          organization: locationHistory.Organization,
          location: locationHistory.Location,
          address: locationHistory.Address,
          gateway: locationHistory.Gateway,
        }))) ||
      [];
    yield put(fetchLocationHistorySuccess(locationHistoryData));
  } catch (error) {
    yield put(fetchLocationHistoryFailure(error.message));
  }
}

async function fetchLocationAPI(deviceId, startDate) {
  const response = await fetch(fetchLocationHistorymapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      startDate: startDate,
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchBatteryHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.battery
      };
    });

    const batteryHistoryResponse = yield call(
      fetchBatteryHistoryAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );

    const batteryHistoryData = Object.entries(
      batteryHistoryResponse?.battery || {}
    );

    let batteryHistory = {
      timeAgo: "",
      battery: [],
    };

    if (Array.isArray(batteryHistoryData)) {
      batteryHistory = batteryHistoryData.reduce(
        (acc, batteryData) => {
          // const localeDateString = batteryData[0].split("T")[0];
          // const availableIndex = acc.battery.findIndex(
          //   (bat) => bat[0].split("T")[0] === localeDateString
          // );

          // if (availableIndex === -1) {
          //   acc = {
          //     battery: [...acc.battery, [batteryData[0], batteryData[1].Value]],
          //   };
          // } else if (acc.battery[availableIndex][1] < batteryData[1].Value) {
          //   acc.battery[availableIndex] = [
          //     batteryData[0],
          //     batteryData[1].Value,
          //   ];
          // }

          acc = {
            battery: [...acc.battery, [batteryData[0], batteryData[1].Value]],
          };

          return acc;
        },
        {
          timeAgo: "",
          battery: [],
        }
      );
    }

    batteryHistory = {
      ...batteryHistory,
      timeAgo: timeAgoCalculator(
        batteryHistory.battery[batteryHistory.battery.length - 1][0]
      ),
    };
    yield put(fetchBatteryHistorySuccess(batteryHistory));
  } catch (error) {
    console.log("error", error);
    yield put(fetchBatteryHistoryFailure(error.message));
  }
}
function* fetchAssetHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.battery
      };
    });

    const AssetHistoryResponse = yield call(
      fetchAssetHistoryAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );
    const assetmapdata = AssetHistoryResponse?.data?.length > 0 && AssetHistoryResponse?.data?.map((item, index) => ({
      id: index + 1,
      coordinates: [item?.fields?.location?.longitude, item?.fields?.location?.latitude],
      lastupdated: item?.lastupdated
    }));
    let GpsMap = {
      type: "FeatureCollection",
      features: assetmapdata.length > 0 && assetmapdata.map((point, idx) => ({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: point.coordinates,
        },
        properties: {
          id: point.id,
          color: idx === 0
            ? "#05A94D"
            : idx === assetmapdata.length - 1
              ? "#C02B03"
              : "#09C3F1",
          number: point.id,
        },
      }))
    };
    
    yield put(fetchAssetHistorySuccess(GpsMap));
  } catch (error) {
    console.log("error", error);
    yield put(fetchAssetHistoryFailure(error.message));
  }
}

async function fetchBatteryHistoryAPI(deviceId, selectedDate, duration, resolution) {
  const dt = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchDeviceEventDashboard(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      eventtype: "battery",
      startDate: dt.endDateTime,
      interval: duration,
      resolution: resolution
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchShockAlarmHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.shockAlarm
      };
    });

    const shockHistoryResponse = yield call(
      fetchShockAlarmHistoryAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );

    console.log('🔍 Shock API Response:', shockHistoryResponse);
    console.log('🔍 Shock data object:', shockHistoryResponse?.shock);

    const shockHistoryData = Object.entries(
      shockHistoryResponse?.shock || {}
    );

    console.log('🔍 Shock entries after Object.entries:', shockHistoryData.length, shockHistoryData.slice(0, 2));

    let shockHistory = {
      timeAgo: "",
      shock: [],
    };

    if (Array.isArray(shockHistoryData)) {
      shockHistory = shockHistoryData.reduce(
        (acc, shockData, index) => {
          // shockData[0] = timestamp
          // shockData[1] = { Value: number, deviceAlarm: { shock: {...} } }
          const eventPayload = shockData[1];

          if (index === 0) {
            console.log('🔍 First shock data entry:', shockData);
            console.log('🔍 Event payload structure:', JSON.stringify(eventPayload, null, 2));
          }

          // Extract magnitude from middleware response
          // Middleware returns: { Value: magnitude, deviceAlarm: { shock: {...} } }
          let magnitude = eventPayload?.Value;

          // Fallback to nested structure if Value not present
          if (magnitude === undefined || magnitude === null) {
            magnitude = eventPayload?.deviceAlarm?.shock?.magnitude;
          }

          if (index === 0) {
            console.log('🔍 Extracted magnitude:', magnitude, 'Type:', typeof magnitude);
          }

          // Only add data points with valid magnitude values
          if (typeof magnitude === 'number' && !isNaN(magnitude)) {
            acc = {
              shock: [...acc.shock, [shockData[0], magnitude, eventPayload]],
            };
          } else if (index === 0) {
            console.warn('⚠️ Magnitude is not a number! Value:', magnitude, 'Type:', typeof magnitude);
          }

          return acc;
        },
        {
          timeAgo: "",
          shock: [],
        }
      );
    }

    console.log('🔍 Final shock history:', shockHistory.shock.length, 'entries');

    // Sort shock data by timestamp (ascending order - oldest first, newest last)
    shockHistory.shock.sort((a, b) => {
      const timeA = new Date(a[0]).getTime();
      const timeB = new Date(b[0]).getTime();
      return timeA - timeB;
    });

    console.log('🔍 After sorting - first:', shockHistory.shock[0]?.[0], 'last:', shockHistory.shock[shockHistory.shock.length - 1]?.[0]);

    shockHistory = {
      ...shockHistory,
      timeAgo: shockHistory.shock.length > 0
        ? timeAgoCalculator(shockHistory.shock[shockHistory.shock.length - 1][0])
        : "",
    };

    console.log('🔍 Dispatching shock history to reducer:', {
      timeAgo: shockHistory.timeAgo,
      shockCount: shockHistory.shock.length,
      firstEntry: shockHistory.shock[0]
    });

    yield put(fetchShockAlarmHistorySuccess(shockHistory));
  } catch (error) {
    console.log("error", error);
    yield put(fetchShockAlarmHistoryFailure(error.message));
  }
}

async function fetchShockAlarmHistoryAPI(deviceId, selectedDate, duration, resolution) {
  const dt = usDateFormatLast7Days(selectedDate);
  const accountId = sessionStorage.getItem("accountId");

  console.log('🔍 Shock API Request:', {
    deviceId,
    accountId,
    eventtype: 'deviceAlarm',
    startDate: dt.endDateTime,
    interval: duration,
    resolution: resolution,
    endpoint: 'AMT Insights /deviceeventdashboard'
  });

  const response = await fetch(fetchDeviceEventDashboard(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
      "X-Transaction-Id": uuidv4(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      accountname: accountId,  // Add accountname for ThingSpace Core API
      eventtype: "deviceAlarm",
      startDate: dt.endDateTime,
      interval: duration,
      resolution: resolution
    }),
  });

  console.log('🔍 Response status:', response.status, response.statusText);

  if (!response.ok) {
    console.error('❌ API error:', response.status, response.statusText);
    return { shock: {} };
  }

  const responseData = await response.json();
  console.log('🔍 Raw API response:', responseData);

  // Response format from middleware: { "shock": { "timestamp": { Value, deviceAlarm } } }
  return responseData;
}

async function fetchAssetHistoryAPI(deviceId, selectedDate, duration, resolution) {
  const { startDateTime, endDateTime } = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      $filter: `(deviceid eq '${deviceId}' AND $/fields containskey 'location' AND $/fields/location/type eq 'gps' AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [
        { field: "createdon", order: "asc" }
      ],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchAcclerationHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.acceleration
      };
    });

    const acclerationHistoryResponse = yield call(
      fetchAcclerationHistoryAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );
    const acclerationHistoryData = Object.entries(
      acclerationHistoryResponse?.acceleration || {}
    );
    let acclerationHistory = {
      accelerationX: [],
      accelerationY: [],
      accelerationZ: [],
      accelerationRMS: [],
    };
    if (Array.isArray(acclerationHistoryData) && acclerationHistoryData.length > 0) {
      acclerationHistoryData.forEach((acclerationData) => {
        acclerationHistory = {
          ...acclerationHistory,
          accelerationX: [
            ...acclerationHistory.accelerationX,
            [acclerationData[0], parseFloat(acclerationData[1].x)],
          ],
          accelerationY: [
            ...acclerationHistory.accelerationY,
            [acclerationData[0], parseFloat(acclerationData[1].y)],
          ],
          accelerationZ: [
            ...acclerationHistory.accelerationZ,
            [acclerationData[0], parseFloat(acclerationData[1].z)],
          ],
          accelerationRMS: [
            ...acclerationHistory.accelerationRMS,
            [acclerationData[0], parseFloat(acclerationData[1].rms)],
          ],
        };
      });
    }else{
      acclerationHistory = {
        accelerationX: [],
        accelerationY: [],
        accelerationZ: [],
        accelerationRMS: [],
      };
    }


    yield put(fetchAcclerationHistorySuccess(acclerationHistory));
  } catch (error) {
    yield put(fetchAcclerationHistoryFailure(error.message));
  }
}

async function fetchAcclerationHistoryAPI(deviceId, selectedDate, duration, resolution) {
  const dt = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchDeviceEventDashboard(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      eventtype: "acceleration",
      startDate: dt.endDateTime,
      interval: duration,
      resolution: resolution
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchSignalHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
        resolutionFilter: state.deviceDashboard.resolutionFilters.signalStrength
      };
    });

    const signalStrengthHistoryResponse = yield call(
      fetchSignalHistoryAPI,
      options.currentId,
      options.selectedDateTime,
      options.resolutionFilter.duration,
      options.resolutionFilter.resolution
    );

    const signalStrengthHistoryData = Object.entries(
      signalStrengthHistoryResponse?.signalStrength || {}
    );
    let signalStrengthHistory = [];

    if (Array.isArray(signalStrengthHistoryData)) {
      signalStrengthHistoryData.sort((a, b) => new Date(a[0]) - new Date(b[0]));
      signalStrengthHistoryData.forEach((signalStrength) => {
        signalStrengthHistory = [
          ...signalStrengthHistory,
          [signalStrength[0], signalStrength[1].Value],
        ];
      });
    }
    yield put(fetchSignalHistorySuccess(signalStrengthHistory));
  } catch (error) {
    yield put(fetchSignalHistoryFailure(error.message));
  }
}

async function fetchSignalHistoryAPI(deviceId, selectedDate, duration, resolution) {
  const dt = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchDeviceEventDashboard(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      deviceid: deviceId,
      eventtype: "signalStrength",
      startDate: dt.endDateTime,
      interval: duration,
      resolution: resolution
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* fetchGatewayTelemetryHistorySaga() {
  try {
    const options = yield select((state) => {
      return {
        currentId: state.deviceDashboard.currentId,
        selectedDateTime: state.deviceDashboard.selectedDateTime,
      };
    });

    const gatewayTelemetryHistoryResponse = yield call(
      fetchGatewayTelemetryHistoryAPI,
      options.currentId,
      options.selectedDateTime
    );

    const gatewayTelemetryHistoryData =
      Array.isArray(gatewayTelemetryHistoryResponse?.data) &&
      gatewayTelemetryHistoryResponse?.data.map(
        (gatewayTelemetryHistory, index) => ({
          key: `${index}-${gatewayTelemetryHistory.id}`,
          timestamp: dateFormatWithAt(gatewayTelemetryHistory.createdon),
          latlong:
            gatewayTelemetryHistory?.fields?.location?.latitude &&
            `${gatewayTelemetryHistory?.fields?.location?.latitude},${gatewayTelemetryHistory?.fields?.location?.longitude}`,
          accuracy: gatewayTelemetryHistory?.fields?.location?.accuracy,
          signalType: gatewayTelemetryHistory?.fields?.location?.type,
          rssi: gatewayTelemetryHistory?.fields?.signalStrength,
          battery: gatewayTelemetryHistory?.fields?.battery,
        })
      );

    yield put(fetchGatewayTelemetryHistorySuccess(gatewayTelemetryHistoryData));
  } catch (error) {
    yield put(fetchGatewayTelemetryHistoryFailure(error.message));
  }
}

async function fetchGatewayTelemetryHistoryAPI(deviceId, selectedDate) {
  const { startDateTime, endDateTime } = usDateFormatLast7Days(selectedDate);
  const response = await fetch(fetchassetmapEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      $filter: `(deviceid eq '${deviceId}' AND ($/fields containskey 'location' OR $/fields containskey 'battery' OR $/fields containskey 'signalStrength') AND createdon between('${startDateTime}','${endDateTime}'))`,
      $sort: [{ field: "createdon", order: "desc" }],
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

export function* DeviceDashboardRSSIHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_RSSI_HISTORY_REQUEST,
    fetchRSSIHistorySaga
  );
}

export function* DeviceDashboardLocationHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_LOCATION_HISTORY_REQUEST,
    fetchLocationHistorySaga
  );
}

export function* DeviceDashboardBatteryHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST,
    fetchBatteryHistorySaga
  );
}
export function* DeviceDashboardAssetHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_ASSET_HISTORY_REQUEST,
    fetchAssetHistorySaga
  );
}


export function* DeviceDashboardAcclerationHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_ACCLERATION_HISTORY_REQUEST,
    fetchAcclerationHistorySaga
  );
}

export function* DeviceDashboardSignalHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST,
    fetchSignalHistorySaga
  );
}

export function* DeviceDashboardGatewayTelemetrySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_GATEWAY_TELEMETRY_HISTORY_REQUEST,
    fetchGatewayTelemetryHistorySaga
  );
}

export function* DeviceDashboardShockAlarmHistorySaga() {
  yield takeLatest(
    deviceDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST,
    fetchShockAlarmHistorySaga
  );
}
